import dev from './dev.json';

const projectFiles = require.context('./projects', true, /\.json$/);
const projects = projectFiles
  .keys()
  .reduce((projects: any, projectPath: any) => {
    const projectName = projectPath.replace(/^\.\/(.*)\.\w+$/, '$1');
    const value = projectFiles(projectPath);
    projects[projectName] = value;
    return projects;
  }, {});

const configs = { ...dev, projects };
export default configs;
